const constants = require('./constants/constants')
const rest = require('./rest')

export function openSalesForce(email, callback) {
  const sfurl = getSFLoginURL()
  console.log('sfurl ', sfurl)
  openPopup(sfurl, callback)
}

function getSFLoginURL() {
  const urlData =
    constants.SF_LOGIN_PAGE +
    constants.SF_API_ID +
    '&redirect_uri=' +
    constants.SF_CALL_BACK_URL
  return urlData
}

export function constructUrl(path) {
  const url = constants.BASE_URL + constants.PORT + path
  return url
}

export function constructSalesgearUrl(path) {
  return constants.BASE_URL + path
}

export function openPopup(url, callback) {
  const w = 600
  const h = 600
  const left = screen.width / 2 - w / 2
  const top = screen.height / 2 - h / 2

  let win = window.open(
    url,
    'popname',
    `status=1, height=${h}, width=${w},top=${top},left=${left}, toolbar=0,resizable=0`
  )

  let id = setInterval(function() {
    if (win.closed == true) {
      clearInterval(id)
      callback()
      console.log('tis is closed')
    }
  }, 1000)
}
const europeanTimeZone = {
  _C_GMT_PLUS_1: 'GMT+01:00',
  _C_GMT_PLUS_2: 'GMT+02:00',
  _C_GMT_PLUS_3: 'GMT+03:00'
}

export const getUsersTimeZone = () => {
  let currentTimeInGmt =
    new Date().toString().slice(25, 31) +
    ':' +
    new Date().toString().slice(31, 33)
  const zoneNames = [
    'Eniwetok, Kwajalein',
    'Midway Island, Samoa',
    'Hawaii',
    'Alaska',
    'Pacific Time US/Canada',
    'Mountain Time US/Canada',
    'Central Time US/Canada, Mexico City',
    'Eastern Time US/Canada, Bogota, Lima',
    'Atlantic Time Canada, Caracas, La Paz',
    'Newfoundland',
    'Brazil, Buenos Aires, Georgetown',
    'America/St_Johns',
    'Mid-Atlantic',
    'Azores, Cape Verde Islands',
    'Western Europe Time, London, Lisbon, Casablanca',
    'Brussels, Copenhagen, Madrid, Paris',
    'Kaliningrad, South Africa',
    'Baghdad, Riyadh, Moscow, St. Petersburg',
    'Tehran',
    'Abu Dhabi, Muscat, Baku, Tbilisi',
    'Kabul',
    'Ekaterinburg, Islamabad, Karachi, Tashkent',
    'Chennai, Mumbai, New Delhi, Kolkata',
    'Kathmandu',
    'Almaty, Dhaka, Colombo',
    'Asia/Rangoon',
    'Bangkok, Hanoi, Jakarta',
    'Beijing, Perth, Singapore, Hong Kong',
    'Asia/Pyongyang',
    'Australia/Eucla',
    'Tokyo, Seoul, Osaka, Sapporo, Yakutsk',
    'Adelaide, Darwin',
    'Eastern Australia, Guam, Vladivostok',
    'Australia/LHI',
    'Magadan, Solomon Islands, New Caledonia',
    'Auckland, Wellington, Fiji, Kamchatka',
    'Antarctica/McMurdo',
    'NZ-CHAT',
    'Etc/GMT-14'
  ]
  const zoneValues = [
    'GMT-12:00',
    'GMT-11:00',
    'GMT-10:00',
    'GMT-09:00',
    'GMT-08:00',
    'GMT-07:00',
    'GMT-06:00',
    'GMT-05:00',
    'GMT-04:00',
    'GMT-03:30',
    'GMT-03:00',
    'GMT-02:30',
    'GMT-02:00',
    'GMT-01:00',
    'GMT+00:00',
    'GMT+01:00',
    'GMT+02:00',
    'GMT+03:00',
    'GMT+03:30',
    'GMT+04:00',
    'GMT+04:30',
    'GMT+05:00',
    'GMT+05:30',
    'GMT+05:45',
    'GMT+06:00',
    'GMT+06:30',
    'GMT+07:00',
    'GMT+08:00',
    'GMT+08:30',
    'GMT+08:45',
    'GMT+09:00',
    'GMT+09:30',
    'GMT+10:00',
    'GMT+10:30',
    'GMT+11:00',
    'GMT+12:00',
    'GMT+13:00',
    'GMT+13:45',
    'GMT+14:00'
  ]
  let position = zoneValues.indexOf(currentTimeInGmt)
  if (position !== -1) {
    return {
      zone_name: zoneNames[position],
      zone_value: zoneValues[position]
    }
  } else {
    return {
      zone_name: 'Pacific Time US/Canada',
      zone_value: 'GMT-08:00'
    }
  }
}

export const validateEUTimeZone = () => {
  let userTimezone = getUsersTimeZone()
  userTimezone = userTimezone.zone_value
  if (
    userTimezone === europeanTimeZone._C_GMT_PLUS_1 ||
    userTimezone === europeanTimeZone._C_GMT_PLUS_2 ||
    userTimezone === europeanTimeZone._C_GMT_PLUS_3
  ) {
    return true
  } else {
    return false
  }
}

export const getQueryParamFromUrl = url => {
  if (!url) url = location.search
  var query = url.substr(1)
  var result = {}
  query.split('&').forEach(function(part) {
    var item = part.split('=')
    result[item[0]] = decodeURIComponent(item[1])
  })
  return result
}

const getLocationData1 = () => {
  var geoIpLookupData = {}
  if (
    !localStorage.getItem('country') &&
    !localStorage.getItem('state') &&
    !localStorage.getItem('city')
  ) {
    rest
      .getFromCustomUrl('https://ipinfo.io/?token=6b302104fd22d1')
      .then(function(response) {
        geoIpLookupData.country =
          response.data && response.data.country ? response.data.country : ''
        geoIpLookupData.state =
          response.data && response.data.region ? response.data.region : ''
        geoIpLookupData.city =
          response.data && response.data.city ? response.data.city : ''
        localStorage.setItem('country', geoIpLookupData.country)
        localStorage.setItem('state', geoIpLookupData.state)
        localStorage.setItem('city', geoIpLookupData.city)
      })
  }
}

export const postDomChangeAlert = data => {
  data.version = process.env.BUILD_VERSION
  rest
    .post(constants.URLS.domChangeAlert, data)
    .then(response => {
      response.json().then(() => {})
    })
    .catch(error => {
      console.error('Error:', error)
    })
}

export const getLocationData = () => {
  var geoIpLookupData = {}
  if (
    !localStorage.getItem('country') &&
    !localStorage.getItem('state') &&
    !localStorage.getItem('city')
  ) {
    rest.getFromCustomUrl('https://ipinfo.io/?token=76787655874909').then(
      function(response) {
        geoIpLookupData.country =
          response.data && response.data.country ? response.data.country : ''
        geoIpLookupData.state =
          response.data && response.data.region ? response.data.region : ''
        geoIpLookupData.city =
          response.data && response.data.city ? response.data.city : ''
        localStorage.setItem('country', geoIpLookupData.country)
        localStorage.setItem('state', geoIpLookupData.state)
        localStorage.setItem('city', geoIpLookupData.city)
      },
      function(data) {
        if (data && data.status && data.status == 429) {
          getLocationData1()
        }
      }
    )
  }
}

export const readCookie = function(name) {
  var nameEQ = name + '='
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) == ' ') c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)
  }
  return null
}

export const setCookie = function(cname, cvalue, exdays, exHours) {
  var d = new Date()
  if (exHours == undefined) {
    exHours = 24
  }
  d.setTime(
    d.getTime() + exdays * 24 * 60 * 60 * 1000 + exHours * 60 * 60 * 1000
  )
  var expires = 'expires=' + d.toUTCString()
  var domain = window.location.host
  if (domain.includes('localhost:8081')) {
    domain = 'localhost'
  }
  domain = domain.replace('www', '')
  var curDomain = 'domain=' + domain + ';'
  document.cookie = cname + '=' + cvalue + ';' + curDomain + expires + ';path=/'
}

export const generateCaptchaToken = () => {
  // eslint-disable-next-line no-undef
  if (grecaptcha != undefined) {
    // eslint-disable-next-line no-undef
    return grecaptcha
      .execute(constants.GOOGLE_CAPTCHA_SITE_KEY, { action: 'forgotpassword' })
      .then(function(token) {
        return token
      })
  } else {
    return null
  }
}

export const windowUrlRedirect = (url, target = '_blank') => {
  if (url) {
    window.open(url, target)
  }
}

export const ifModeTenPresentBetweenTwoNumbers = (start, end) => {
  const multiplesOf10Reverse = Array.from(
    { length: start - end + 1 },
    (_, i) => start - i
  ).filter(number => number % 10 === 0 && number !== start)
  return multiplesOf10Reverse.length > 0 || false
}

export const checkAndShowG2ReviewPopup = (
  userType,
  previousCredits,
  currentCredits
) => {
  if (
    userType === 'FREE' &&
    ((previousCredits > 45 && currentCredits <= 45) || // 5th credit consume
      ifModeTenPresentBetweenTwoNumbers(previousCredits, currentCredits)) &&
    readCookie('review_clicked') != 'true' &&
    localStorage.getItem('review_clicked') != 'true'
  ) {
    return true
  }
  return false
}

export const checkAndAddHttpProtocol = value => {
  if (value.includes('http://') || value.includes('https://')) {
    return value
  }
  return `https://${value}`
}
